import { render, staticRenderFns } from "./DlvRL.vue?vue&type=template&id=2a608548"
import script from "./DlvRL.vue?vue&type=script&lang=js"
export * from "./DlvRL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports